import { render, staticRenderFns } from "./inspectionTemplate.vue?vue&type=template&id=6ca10196&scoped=true&"
import script from "./inspectionTemplate.vue?vue&type=script&lang=js&"
export * from "./inspectionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./inspectionTemplate.vue?vue&type=style&index=0&id=6ca10196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca10196",
  null
  
)

export default component.exports